import script from "./Automated_Operation.vue?vue&type=script&setup=true&lang=js"
export * from "./Automated_Operation.vue?vue&type=script&setup=true&lang=js"

import "./Automated_Operation.vue?vue&type=style&index=0&id=4d1884af&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d1884af"]])

export default __exports__